import { useQuery, useMutation } from "@tanstack/react-query";
import { retentionApiService } from "modules/Pharmacy/Retention/api/retention.api";
import { RetentionFormValues } from "modules/Pharmacy/Retention/helpers/retention.types";

interface ApiResponse<T = any> {
  data: T;
  message: string;
  statuscode: number;
}

export const useRetentionService = ({
  searchText,
  pageNumber = 1,
  pageSize,

  studyid,
  enableSelectall = false,
}: {
  searchText?: string | null;
  pageNumber?: number;
  pageSize?: number;

  studyid?: number | string | null;
  enableSelectall?: boolean;
} = {}) => {

  // SELECT ALL
  const SelectAllQuery = useQuery({
    queryKey: [
      "retention-selectAll",
      { searchText, pageNumber, pageSize, studyid },
    ],
    queryFn: () =>
      retentionApiService.getSelectAllData({
        searchtext: searchText ?? null,
        currentpage: pageNumber,
        pagesize: pageSize,
        status: "A",

        studyid: studyid ?? null,
      }),
      enabled: enableSelectall,
  });

  // DELETE
  const DeleteMutation = useMutation<ApiResponse, Error, { retentionid: number | null, updatereason: string }>({
    mutationFn: (payload) =>
      retentionApiService.deleteData(payload),
  });

  // INSERT
  const InsertMutation = useMutation({
    mutationFn: (payload: RetentionFormValues) => retentionApiService.insertData(payload),
  });

  // UPDATE
  const UpdateMutation = useMutation({
    mutationFn: (payload: RetentionFormValues & { updatereason: string; }) => retentionApiService.updateData(payload),
  });

  // SELECT BY ID
  const SelectIdQuery = (retentionid: number | string | null) =>
    useQuery({
      queryKey: ["retention-select", retentionid],
      queryFn: () => retentionApiService.getSelectData(retentionid!),
      enabled: !!retentionid,
    });

  const verifyPinMutation = useMutation({
    mutationFn: (payload: { verifypin: string, retentionid: number, studyid: number, verifiedby: number }) => retentionApiService.verifyPin(payload),
  });

  return { SelectAllQuery, InsertMutation, UpdateMutation, DeleteMutation, SelectIdQuery, verifyPinMutation };
};
